export default "__VITE_ASSET__B4p8g_Kz__"